<template>
  <div class="commonDialog" :class="{'notice': isNotice}">
    <van-dialog v-model="dialogData.show" :show-confirm-button="false">
      <div class="title" v-show="dialogData.title">{{dialogData.title}}</div>
      <div class="pic" v-show="dialogData.imgUrl"><img :src="dialogData.imgUrl"></div>
      <div class="text" v-html="dialogData.text"></div>
      <div class="confirmA" v-show="dialogData.confirmA" @click="confirmA">{{dialogData.confirmA}}</div>
      <div class="confirmB" v-show="dialogData.confirmB" @click="confirmB">{{dialogData.confirmB}}</div>
    </van-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  props: {
    dialogData: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    isNotice() {
      return this.dialogData.layerType === 'notice'
    }
  },
  methods: {
    // 高亮按钮
    confirmA () {
      this.$emit('confirmA')
    },
    // 白色背景按钮
    confirmB () {
      this.$emit('confirmB')
    }
  }
}
</script>

<style scoped lang="scss">
.commonDialog {
  .van-dialog{
    font-family: Roboto, Roboto-Regular;
    font-size: 32px;
    font-weight: 400;
    padding: 60px 48px 40px;
    box-sizing: border-box;
    width: 592px;
    border-radius: 36px;
    box-shadow: 0px 2px 4px 0px rgba(196,202,213,0.20);
  }
  .title{
    font-size: 40px;
    font-family: Roboto, Roboto-Medium;
    font-weight: 700;
    text-align: center;
    color: #1b3155;
    line-height: 40px;
    padding-top: 12px;
    padding-bottom: 44px;
  }
  .pic{
    padding-bottom: 16px;
    img{
      width: 95%;
      margin: 0 auto;
    }
  }
  .text{
    text-align: center;
    color: #1b3155;
    line-height: 44px;
    /deep/ span{
      color: #27ae60;
    }
    /deep/ .list{
      color: #1B3155;
      text-align: left;
      margin-top: 32px;
      padding-left: 26px;
      position: relative;
      word-wrap: break-word;
      i{
        width: 16px;
        height: 16px;
        background: #FFBC11;
        border-radius: 50%;
        display: block;
        position: absolute;
        top: 17px;
        left: 0;
      }
    }
    /deep/ .list:first-child{
      margin-top: 0;
    }
  }
  .confirmA{
    height: 88px;
    line-height: 88px;
    background: #27ae60;
    border-radius: 53px;
    color: #fff;
    margin: 52px 0 12px;
  }
  .confirmB{
    height: 88px;
    line-height: 88px;
    background: #fff;
    color: #27ae60;
    border-radius: 53px;
  }
}
.commonDialog.notice{
  .title{
    text-align: left;
  }
  .text{
    text-align: left;
  }
}
</style>
